// extracted by mini-css-extract-plugin
export default {"PTC":"PTClub_PTC__FfuYq","Logo":"PTClub_Logo__j3JMa"};